<div
  *ngIf="field && (field.hide || field.props?.['hideField'])"
  class="irembogov-hidden-hide-fields-placeholder {{
    field.type === 'formly-group' ? 'my-3' : 'my-5'
  }} {{ field.hide ? 'status-hide' :  (field.props?.['hideField'] ? 'status-hide-field' : '') }}">
  <span class="status-label">
    <span
      class="badge bg-info"
      placement="auto"
      ngbTooltip="*field.hide=true"
      *ngIf="field.hide">
      <i class="icon-slash-circle-01 me-1"></i>
      Hidden {{ descriptionName }}
    </span>

    <span
      class="badge bg-warning text-dark"
      placement="auto"
      ngbTooltip="*field.props.hideField=true"
      *ngIf="field.props?.['hideField']">
      <i class="icon-eye-off me-1"></i>
      Non-Display {{ descriptionName }}</span
    >
  </span>
  <div class="title-head border-bottom d-flex align-items-center">
    <strong class="text-muted align-items-center">
      <i class="icon-file-06"></i>
      {{ field.props?.label }}
    </strong>

    <irembogov-settings-toolbar
      class="ms-auto d-flex"
      [label]="field.props?.label"
      [type]="field | fieldTypeAsString"
      [field]="field"
      (fieldConfigActionEvent)="
        fieldConfigActionEvent.emit($event)
      "></irembogov-settings-toolbar>
  </div>
  <small class="w-100 text-muted">
    Key: {{ field.key }} &nbsp; | &nbsp; Type: {{ field.type }}
  </small>
  <small class="text-danger d-block" *ngIf="field.props?.['hideField']">
    <div
      *ngIf="field.formControl?.errors"
      class="invalid-feedback"
      [style.display]="'block'">
      <formly-validation-message
        id="{{ field.id }}-formly-validation-error"
        [field]="field"
        role="alert"></formly-validation-message>
    </div>
  </small>
</div>
